import React, { useState } from "react";
import "./OutofStockPopup.css";
import { FaExclamationTriangle } from "react-icons/fa";

// import popupImg from "../../../Assets/Banner/sold_out_banner.jpg";

const OutofStockPopup = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  const handleClose = () => {
    setFadeOut(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 300);
  };

  return (
    showPopup && (
      <div className="popup-overlay">
        <div className={`popup-content ${fadeOut ? "fade-out" : ""}`}>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
          {/* <div className="popup-left">
            <img src={popupImg} alt="Newsletter" />
          </div> */}
          <div className="popup-right">
            <div className="popup-heading">
              <FaExclamationTriangle className="warning-icon" />
              <h2>Temporarily Out of Stock</h2>
            </div>
            <p>
              We're sorry! This item is temporarily out of stock. Please check
              back later or explore other products in our catalog.
            </p>
          </div>
        </div>
      </div>
    )
  );
};

export default OutofStockPopup;
